import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { FormItem } from "./FormItem";
import { FormControl } from "./FormControl";
import { createRocket } from "../_util/create-rocket";
import { FormContext } from "./FormContext";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var FormText = createRocket("Form.Text", "div.@{prefix}-form__text");
export var FormTitle = createRocket("Form.Title", "h3.@{prefix}-form-title");
export var FormAction = createRocket("Form.Action", "div.@{prefix}-form-operate");
export var Form = forwardRefWithStatics(function Form(_a, ref) {
    var _b;
    var layout = _a.layout, readonly = _a.readonly, hideLabel = _a.hideLabel, fixedLabelWidth = _a.fixedLabelWidth, children = _a.children, className = _a.className, props = __rest(_a, ["layout", "readonly", "hideLabel", "fixedLabelWidth", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    // readonly 只和 fixed 共存
    var formClassName = classNames(classPrefix + "-form", (_b = {},
        _b[classPrefix + "-form--fixed-layout"] = layout === "fixed",
        _b[classPrefix + "-form--vertical"] = !readonly && (layout === "vertical" || layout === "inline-vertical"),
        _b[classPrefix + "-form--inline"] = !readonly && (layout === "inline" || layout === "inline-vertical"),
        _b[classPrefix + "-form--readonly"] = readonly,
        _b), className);
    return (React.createElement("div", __assign({ ref: ref, className: formClassName }, props),
        React.createElement(FormContext.Provider, { value: {
                hideLabel: hideLabel,
                fixedLabelWidth: layout === "fixed" ? fixedLabelWidth : undefined,
            } }, children)));
}, {
    Item: FormItem,
    Title: FormTitle,
    Action: FormAction,
    Control: FormControl,
    Text: FormText,
});
Form.displayName = "Form";
//# sourceMappingURL=Form.js.map